// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gportal/api/user/v1/rpc.proto (package gportal.api.user.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ChangeCurrencyRequest, ChangeParanoidRequest, ChangePreferredRegionRequest, CheckLootPassDiscordStatusRequest, CreateCustomerRequest, GetCustomerRequest, GetGamecloudSubscriptionsRequest, GetProfileRequest, GetSubscriptionInfosRequest, GetUserRequest, LinkLootPassDiscordRoleRequest, NewsletterOptInRequest, NewsletterOptOutRequest, PauseGamecloudSubscriptionRequest, RegisterUserRequest, RegisterUserRequirementsRequest, ResendVerificationEmailRequest, ResumeGamecloudSubscriptionRequest, UpdateBillingAddressRequest, VerifyEmailRequest } from "./requests_pb.js";
import { ChangeCurrencyResponse, ChangeParanoidResponse, ChangePreferredRegionResponse, CheckLootPassDiscordStatusResponse, CreateCustomerResponse, GetCustomerResponse, GetGamecloudSubscriptionsResponse, GetProfileResponse, GetSubscriptionInfosResponse, GetUserResponse, LinkLootPassDiscordRoleResponse, NewsletterOptInResponse, NewsletterOptOutResponse, PauseGamecloudSubscriptionResponse, RegisterUserRequirementsResponse, RegisterUserResponse, ResendVerificationEmailResponse, ResumeGamecloudSubscriptionResponse, UpdateBillingAddressResponse, VerifyEmailResponse } from "./responses_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gportal.api.user.v1.UserService
 */
export const UserService = {
  typeName: "gportal.api.user.v1.UserService",
  methods: {
    /**
     * @generated from rpc gportal.api.user.v1.UserService.RegisterUser
     */
    registerUser: {
      name: "RegisterUser",
      I: RegisterUserRequest,
      O: RegisterUserResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gportal.api.user.v1.UserService.RegisterUserRequirements
     */
    registerUserRequirements: {
      name: "RegisterUserRequirements",
      I: RegisterUserRequirementsRequest,
      O: RegisterUserRequirementsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gportal.api.user.v1.UserService.ResendVerificationEmail
     */
    resendVerificationEmail: {
      name: "ResendVerificationEmail",
      I: ResendVerificationEmailRequest,
      O: ResendVerificationEmailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gportal.api.user.v1.UserService.VerifyEmail
     */
    verifyEmail: {
      name: "VerifyEmail",
      I: VerifyEmailRequest,
      O: VerifyEmailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns basic user information.
     *
     * @generated from rpc gportal.api.user.v1.UserService.GetUser
     */
    getUser: {
      name: "GetUser",
      I: GetUserRequest,
      O: GetUserResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns extended profile information.
     *
     * @generated from rpc gportal.api.user.v1.UserService.GetProfile
     */
    getProfile: {
      name: "GetProfile",
      I: GetProfileRequest,
      O: GetProfileResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns the GPORTAL customer.
     *
     * @generated from rpc gportal.api.user.v1.UserService.GetCustomer
     */
    getCustomer: {
      name: "GetCustomer",
      I: GetCustomerRequest,
      O: GetCustomerResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Create the GPORTAL customer.
     *
     * @generated from rpc gportal.api.user.v1.UserService.CreateCustomer
     */
    createCustomer: {
      name: "CreateCustomer",
      I: CreateCustomerRequest,
      O: CreateCustomerResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates the billing address on the authenticated user's own profile.
     *
     * This is the profile-completion step the Gamecloud checkout ADR asks for: when a customer's
     * stored address is missing or is one Chargebee refuses, the checkout collects the correct
     * address here instead of failing.
     *
     * @generated from rpc gportal.api.user.v1.UserService.UpdateBillingAddress
     */
    updateBillingAddress: {
      name: "UpdateBillingAddress",
      I: UpdateBillingAddressRequest,
      O: UpdateBillingAddressResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gportal.api.user.v1.UserService.ChangePreferredRegion
     */
    changePreferredRegion: {
      name: "ChangePreferredRegion",
      I: ChangePreferredRegionRequest,
      O: ChangePreferredRegionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gportal.api.user.v1.UserService.ChangeCurrency
     */
    changeCurrency: {
      name: "ChangeCurrency",
      I: ChangeCurrencyRequest,
      O: ChangeCurrencyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gportal.api.user.v1.UserService.ChangeParanoid
     */
    changeParanoid: {
      name: "ChangeParanoid",
      I: ChangeParanoidRequest,
      O: ChangeParanoidResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gportal.api.user.v1.UserService.NewsletterOptIn
     */
    newsletterOptIn: {
      name: "NewsletterOptIn",
      I: NewsletterOptInRequest,
      O: NewsletterOptInResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gportal.api.user.v1.UserService.NewsletterOptOut
     */
    newsletterOptOut: {
      name: "NewsletterOptOut",
      I: NewsletterOptOutRequest,
      O: NewsletterOptOutResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Checks if the user fulfills the requirements to link their Discord account for Loot Pass role.
     *
     * @generated from rpc gportal.api.user.v1.UserService.CheckLootPassDiscordStatus
     */
    checkLootPassDiscordStatus: {
      name: "CheckLootPassDiscordStatus",
      I: CheckLootPassDiscordStatusRequest,
      O: CheckLootPassDiscordStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Links the user's Discord account for Loot Pass role.
     *
     * @generated from rpc gportal.api.user.v1.UserService.LinkLootPassDiscordRole
     */
    linkLootPassDiscordRole: {
      name: "LinkLootPassDiscordRole",
      I: LinkLootPassDiscordRoleRequest,
      O: LinkLootPassDiscordRoleResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets available subscriptions information of the current user.
     *
     * @generated from rpc gportal.api.user.v1.UserService.GetSubscriptionInfos
     */
    getSubscriptionInfos: {
      name: "GetSubscriptionInfos",
      I: GetSubscriptionInfosRequest,
      O: GetSubscriptionInfosResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns the list of gamecloud subscriptions for the current user.
     *
     * @generated from rpc gportal.api.user.v1.UserService.GetGamecloudSubscriptions
     */
    getGamecloudSubscriptions: {
      name: "GetGamecloudSubscriptions",
      I: GetGamecloudSubscriptionsRequest,
      O: GetGamecloudSubscriptionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Pauses an active gamecloud subscription.
     *
     * @generated from rpc gportal.api.user.v1.UserService.PauseGamecloudSubscription
     */
    pauseGamecloudSubscription: {
      name: "PauseGamecloudSubscription",
      I: PauseGamecloudSubscriptionRequest,
      O: PauseGamecloudSubscriptionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Resumes a paused gamecloud subscription.
     *
     * @generated from rpc gportal.api.user.v1.UserService.ResumeGamecloudSubscription
     */
    resumeGamecloudSubscription: {
      name: "ResumeGamecloudSubscription",
      I: ResumeGamecloudSubscriptionRequest,
      O: ResumeGamecloudSubscriptionResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

